/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { GlobalErrorsService } from '../../../../libs/services/src/lib/global-errors.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private errorsService: GlobalErrorsService,
              private snackBar: MatSnackBar,
              private router: Router) {
  }

  ngOnInit(): void {
    this.errorsService.unautheticatedError.subscribe(err => {
      alert('Your session has been expired. Please, re-login');
      this.router.navigate(['/auth', 'logout']);
    });
    this.errorsService.networkError.subscribe(err => {
      this.snackBar.open('Please, check your internet connection', 'Ok')
    });
  }
}
